import React, {Component, Fragment} from 'react';
import {
  Card,
  CardBody,
  Row,
  Col,
  Form,
  CardTitle,
  Label,
  Input
} from 'reactstrap';
import {Field, Form as FinalForm} from 'react-final-form';
import {withTranslation} from 'react-i18next';
import TextField from '../../../../components/TextField';
import {Colxx, Separator} from '../../../../components/common/CustomBootstrap';
import {NotificationManager} from '../../../../components/common/react-notifications';
import LoaderButton from '../../../../components/LoaderButton';
import Api from '../../../../services/Api';
import Breadcrumb from '../../../../containers/navs/Breadcrumb';
import ReactQuill, {Quill} from 'react-quill';
import {modules, formats} from '../../../../constants/editorConfig';
import FieldError from '../../../../components/FieldError';
import {required} from '../../../../helpers/Validators';

let AlignStyle = Quill.import('attributors/style/align');
let BackgroundStyle = Quill.import('attributors/style/background');
let ColorStyle = Quill.import('attributors/style/color');
let DirectionStyle = Quill.import('attributors/style/direction');
let FontStyle = Quill.import('attributors/style/font');
let SizeStyle = Quill.import('attributors/style/size');

Quill.register(AlignStyle, true);
Quill.register(BackgroundStyle, true);
Quill.register(ColorStyle, true);
Quill.register(DirectionStyle, true);
Quill.register(FontStyle, true);
Quill.register(SizeStyle, true);

class Create extends Component {
  constructor(props) {
    super(props);
    this.userId = props.location && props.location.state ? props.location.state.userId : undefined;
  }

  createNotification = async values => {
    const {t} = this.props;
    try {
      await Api.invoke(
        'POST',
        this.userId ? '/admin-ui/user-notifications' : '/admin-ui/general-notifications',
        this.userId ? {...values, userId: this.userId} : values
      );
      NotificationManager.success(t('Notification sent successfully'), t('Message'));
    } catch (e) {
      if (e.fieldError) {
        return e.fieldError;
      }
      throw e;
    }
  };

  render() {
    const {t, match} = this.props;
    return (
      <Fragment>
        {!this.userId &&<Row>
          <Colxx xxs="12">
            <Breadcrumb match={match}/>
            <Separator className="mb-5"/>
          </Colxx>
        </Row>}
        <Row>
          <Colxx xxs="12" className="mb-4">
            <Card className="h-100">
              <CardBody>
                <CardTitle className="text-large text-primary">
                  {this.userId ? t('Create User Notification') : t('Create General Notification')}
                </CardTitle>
                <FinalForm
                  onSubmit={this.createNotification}
                  render={({handleSubmit, submitting, pristine, hasValidationErrors}) => {
                    return (
                      <Form onSubmit={handleSubmit}>
                        <Row>
                          <Col>
                            <TextField
                              item={{
                                name: 'title',
                                i18n: t('Title'),
                                type: 'text',
                                required: true,
                              }}
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col>
                            <span>
                             {t('Content')}
                              <span className="required">*</span>
                            </span>
                            <Field name='html' validate={required}>
                              {({input}) => (
                                <ReactQuill
                                  {...input}
                                  theme='snow'
                                  modules={modules}
                                  formats={formats}
                                />
                              )}
                            </Field>
                            <FieldError name='html' />
                          </Col>
                        </Row>
                        <Row className='mt-2'>
                          <Col>
                            <Field name='important'>
                              {({input}) => (
                                <Label check className='d-flex flex-row align-items-center'>
                                  <Input
                                    type="checkbox"
                                    className='m-0'
                                    checked={input.value}
                                    onChange={e => {input.onChange(Number(e.target.checked));}}
                                  />
                                  <span className='ml-3'>{t('Display as soon as the user logs in')}</span>
                                </Label>
                              )}
                            </Field>
                          </Col>
                        </Row>
                        <LoaderButton
                          loading={submitting}
                          onClick={handleSubmit}
                          disabled={pristine || hasValidationErrors || submitting}
                          className="mt-4 text-center"
                          style={{minWidth: '100px'}}>
                          {t('Send')}
                        </LoaderButton>
                      </Form>
                    );
                  }}
                />
              </CardBody>
            </Card>
          </Colxx>
        </Row>
      </Fragment>
    );
  }
}

export default withTranslation()(Create);
